/* eslint import/prefer-default-export: 0 */
import { replaceFilterMergeFields } from './FilterSelector';
import { replaceDataMergeFields } from './DataSelector';

/**
 * Returns the title of the copy modal
 */
export const getCopyTitle = (state, rowId) => replaceFilterMergeFields(state, replaceDataMergeFields(state, rowId, state.copy.title));
